module.exports = __webpack_public_path__ + "img/PR4-B.3d9122d0.png";